export enum ACTIVITY_TASK_TYPE {
    REGULARES = 1,
    APOYO = 2,
    CALIDAD = 3
}

export enum STATUS_PAY {
    PENDIENTE_PAGO = 1,
    PAGADO = 2,
}

export enum LIST_TYPE {
    // PROYECTO = 1,
    // EQUIPO = 0,
    PROYECTO = 1,
    EQUIPO = 2,
}

export const taskMessage: string = "Podrás registrar horas adicionales 1 día hábil luego de la fecha de efecto";